export default {
    apiGetIssueCategories(data = {}) {
        return this.request(this.api().getIssueCategories, data)
            .exec()
            .log()
            .mapresults((response) => response)
            .get();
    },
    apiCreateIssueCategory(data) {
        return this.request(this.api().createIssueCategory, data)
            .exec()
            .log()
            .mapresults((response) => response)
            .get();
    },
    apiUpdateIssueCategory(data, urldata = {}) {
        return this.request(this.api().updateIssueCategory, data)
            .urltransform(urldata)
            .exec()
            .log()
            .mapresults((response) => response)
            .get();
    },
    apiPatchIssueCategory(data = {}, urldata = {}) {
        return this.request(this.api().patchIssueCategory, data)
            .urltransform(urldata)
            .exec()
            .log()
            .mapresults((response) => response)
            .get();
    },
    apiGetIssuePriorities(data = {}) {
        return this.request(this.api().getIssuePriorities, data)
            .exec()
            .log()
            .mapresults((response) => response)
            .get();
    },
    apiCreateIssuePriority(data) {
        return this.request(this.api().createIssuePriority, data)
            .exec()
            .log()
            .mapresults((response) => response)
            .get();
    },
    apiUpdateIssuePriority(data) {
        return this.request(this.api().updateIssuePriority, data)
            .exec()
            .log()
            .mapresults((response) => response)
            .get();
    },
    apiPatchIssuePriority(data = {}, urldata = {}) {
        return this.request(this.api().patchIssuePriority, data)
            .urltransform(urldata)
            .exec()
            .log()
            .mapresults((response) => response)
            .get();
    }
};
